export type EmojiCatalogItem = {
  emoji: string;
  name: string;
  keywords: string[];
};

const emoji = (...codePoints: number[]) => String.fromCodePoint(...codePoints);

export const EMOJI_CATALOG: EmojiCatalogItem[] = [
  { emoji: emoji(0x1f600), name: "grinning", keywords: ["grinning", "smile", "happy"] },
  { emoji: emoji(0x1f603), name: "smiley", keywords: ["smiley", "happy"] },
  { emoji: emoji(0x1f604), name: "smile", keywords: ["smile", "happy"] },
  { emoji: emoji(0x1f601), name: "grin", keywords: ["grin", "smile"] },
  { emoji: emoji(0x1f605), name: "sweat_smile", keywords: ["sweat_smile", "relief"] },
  { emoji: emoji(0x1f606), name: "laughing", keywords: ["laughing", "haha"] },
  { emoji: emoji(0x1f609), name: "wink", keywords: ["wink", "playful"] },
  { emoji: emoji(0x1f60a), name: "blush", keywords: ["blush", "smile", "happy"] },
  { emoji: emoji(0x1f60e), name: "sunglasses", keywords: ["cool", "sunglasses"] },
  { emoji: emoji(0x1f973), name: "partying_face", keywords: ["party", "celebrate"] },
  { emoji: emoji(0x1f60d), name: "heart_eyes", keywords: ["heart_eyes", "love"] },
  { emoji: emoji(0x1f525), name: "fire", keywords: ["fire", "lit", "hot"] },
  { emoji: emoji(0x1f44d), name: "thumbsup", keywords: ["thumbsup", "thumbs_up", "like"] },
  { emoji: emoji(0x1f440), name: "eyes", keywords: ["eyes", "look", "watching"] },
  { emoji: emoji(0x1f389), name: "tada", keywords: ["tada", "party", "celebrate"] },
  { emoji: emoji(0x1f680), name: "rocket", keywords: ["rocket", "launch"] },
  { emoji: emoji(0x1f62f), name: "anguished", keywords: ["anguished", "worried", "distressed"] },
  { emoji: emoji(0x1f632), name: "astonished", keywords: ["astonished", "surprised", "shocked"] },
  { emoji: emoji(0x1f976), name: "cold_face", keywords: ["cold", "cold_face", "freezing"] },
  { emoji: emoji(0x1f630), name: "cold_sweat", keywords: ["cold_sweat", "nervous", "sweat"] },
  { emoji: emoji(0x1f616), name: "confounded", keywords: ["confounded", "frustrated"] },
  { emoji: emoji(0x1f615), name: "confused", keywords: ["confused", "unsure"] },
  { emoji: emoji(0x1f920), name: "cowboy_hat_face", keywords: ["cowboy", "hat", "face"] },
  { emoji: emoji(0x1f622), name: "cry", keywords: ["cry", "sad", "tears"] },
  { emoji: emoji(0x1f602), name: "joy", keywords: ["joy", "laugh", "tears"] },
  { emoji: emoji(0x1f642), name: "slightly_smiling_face", keywords: ["slightly_smiling_face", "smile"] },
  { emoji: emoji(0x1f643), name: "upside_down_face", keywords: ["upside_down_face", "silly"] },
  { emoji: emoji(0x1f972), name: "smiling_face_with_tear", keywords: ["tear", "smile", "emotional"] },
  { emoji: emoji(0x1f607), name: "innocent", keywords: ["innocent", "angel"] },
  { emoji: emoji(0x1f970), name: "smiling_face_with_hearts", keywords: ["hearts", "love"] },
  { emoji: emoji(0x1f618), name: "kissing_heart", keywords: ["kiss", "heart"] },
  { emoji: emoji(0x1f617), name: "kissing", keywords: ["kissing", "kiss"] },
  { emoji: emoji(0x1f61a), name: "kissing_closed_eyes", keywords: ["kiss", "closed_eyes"] },
  { emoji: emoji(0x1f60b), name: "yum", keywords: ["yum", "tongue"] },
  { emoji: emoji(0x1f61b), name: "stuck_out_tongue", keywords: ["tongue", "playful"] },
  { emoji: emoji(0x1f61c), name: "stuck_out_tongue_winking_eye", keywords: ["tongue", "wink"] },
  { emoji: emoji(0x1f92a), name: "zany_face", keywords: ["zany", "crazy"] },
  { emoji: emoji(0x1f92f), name: "exploding_head", keywords: ["mind_blown", "shock"] },
  { emoji: emoji(0x1f648), name: "see_no_evil", keywords: ["peek", "shy", "monkey"] },
  { emoji: emoji(0x1f917), name: "hugs", keywords: ["hugs", "hug"] },
  { emoji: emoji(0x1f64f), name: "pray", keywords: ["pray", "respect", "thanks"] },
  { emoji: emoji(0x1f914), name: "thinking", keywords: ["thinking", "hmm"] },
  { emoji: emoji(0x1f92d), name: "hand_over_mouth", keywords: ["oops", "giggle"] },
  { emoji: emoji(0x1f92b), name: "shushing_face", keywords: ["quiet", "shush"] },
  { emoji: emoji(0x1f925), name: "lying_face", keywords: ["lying", "pinocchio"] },
  { emoji: emoji(0x1f636), name: "no_mouth", keywords: ["silent", "no_mouth"] },
  { emoji: emoji(0x1f47b), name: "ghost", keywords: ["ghost", "disappear"] },
  { emoji: emoji(0x1f610), name: "neutral_face", keywords: ["neutral", "meh"] },
  { emoji: emoji(0x1f615), name: "confused_face", keywords: ["awkward", "confused"] },
  { emoji: emoji(0x1f611), name: "expressionless", keywords: ["expressionless", "blank"] },
  { emoji: emoji(0x1f644), name: "roll_eyes", keywords: ["roll_eyes", "eyeroll"] },
  { emoji: emoji(0x1f62c), name: "grimacing", keywords: ["grimacing", "awkward"] },
  { emoji: emoji(0x1f614), name: "pensive", keywords: ["pensive", "relief"] },
  { emoji: emoji(0x1f62e), name: "open_mouth", keywords: ["open_mouth", "wow"] },
  { emoji: emoji(0x1f971), name: "yawning_face", keywords: ["yawn", "sleepy"] },
  { emoji: emoji(0x1f634), name: "sleeping", keywords: ["sleeping", "sleepy"] },
  { emoji: emoji(0x1f924), name: "drooling_face", keywords: ["drooling", "hungry"] },
  { emoji: emoji(0x1f62a), name: "sleepy", keywords: ["sleepy", "tired"] },
  { emoji: emoji(0x1f635), name: "dizzy_face", keywords: ["dizzy", "confused"] },
  { emoji: emoji(0x1f910), name: "zipper_mouth_face", keywords: ["zipper", "secret"] },
  { emoji: emoji(0x1f974), name: "woozy_face", keywords: ["woozy", "dizzy"] },
  { emoji: emoji(0x1f922), name: "nauseated_face", keywords: ["nauseated", "sick"] },
  { emoji: emoji(0x1f92e), name: "face_vomiting", keywords: ["vomit", "sick"] },
  { emoji: emoji(0x1f927), name: "sneezing_face", keywords: ["sneeze", "sick"] },
  { emoji: emoji(0x1f621), name: "pouting_face", keywords: ["angry", "mad", "pouting"] },
];
